(function () {
	'use strict';

	const containers = document.querySelectorAll('[data-pma-lead-path]');

	if (!containers.length) {
		return;
	}

	const mobileQuery = window.matchMedia('(max-width: 599px)');

	/**
	 * Measure and set the mobile connector line height for each dot.
	 *
	 * This reads the real pixel gap between one dot's bottom edge and the next dot's top edge.
	 *
	 * @return {void}
	 */
	function sizeMobileConnectors() {
		if (!mobileQuery.matches) {
			return;
		}

		containers.forEach((container) => {
			const dots = container.querySelectorAll('.paragon-lead-block__dot');

			dots.forEach((dot, index) => {
				const nextDot = dots[index + 1];

				if (!nextDot) {
					dot.style.removeProperty('--pma-connector-height');
					return;
				}

				const dotRect = dot.getBoundingClientRect();
				const nextRect = nextDot.getBoundingClientRect();
				const distance = Math.max(nextRect.top - dotRect.bottom, 0);

				dot.style.setProperty(
					'--pma-connector-height',
					distance + 'px'
				);
			});
		});
	}

	sizeMobileConnectors();
	window.addEventListener('load', sizeMobileConnectors);

	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(sizeMobileConnectors, 150);
	});

	const prefersReducedMotion = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	if (prefersReducedMotion || !('IntersectionObserver' in window)) {
		return;
	}

	containers.forEach((container) => {
		container.classList.add('pma-js-ready');
	});

	const STAGGER_MS = 450;

	/**
	 * Reveal every milestone in a block, one after another, top to bottom.
	 *
	 * Triggered once per block when it scrolls into view (see the
	 * IntersectionObserver below) — same cascade on mobile and desktop, no
	 * per-item observation needed.
	 *
	 * @param {Element} container The `[data-pma-lead-path]` block element
	 *                            whose milestones should cascade in.
	 * @return {void}
	 */
	function cascadeReveal(container) {
		const items = container.querySelectorAll(
			'.paragon-lead-block__milestone[data-pma-fade]'
		);

		items.forEach((item, index) => {
			window.setTimeout(() => {
				item.classList.add('is-visible');
			}, index * STAGGER_MS);
		});
	}

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				cascadeReveal(entry.target);
				obs.unobserve(entry.target);
			});
		},
		{
			root: null,
			rootMargin: '0px 0px -20% 0px',
			threshold: 0,
		}
	);

	containers.forEach((container) => {
		observer.observe(container);
	});
})();
